import React, { useState, useEffect, useRef } from "react";
import { postsList } from "../../utils/getPosts";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../utils/scrollUtils";

function AnnouncementModal() {
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const autoplayTimerRef = useRef(null);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  const latestPosts = postsList.slice(0, 4);

  useEffect(() => {
    if (!showModal || latestPosts.length <= 2 || isHovered) {
      if (autoplayTimerRef.current) {
        clearInterval(autoplayTimerRef.current);
      }
      return;
    }

    autoplayTimerRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % latestPosts.length);
    }, 5000);

    return () => {
      if (autoplayTimerRef.current) {
        clearInterval(autoplayTimerRef.current);
      }
    };
  }, [showModal, latestPosts.length, isHovered]);

  if (!showModal) return null;

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? latestPosts.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % latestPosts.length);
  };

  const renderSlider = () => {
    const activePost = latestPosts[currentIndex];
    return (
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
          overflow: "hidden",
          padding: "0 50px",
        }}
      >
        {/* Left Arrow */}
        <button
          onClick={handlePrev}
          aria-label="Anterior"
          style={{
            position: "absolute",
            left: "5px",
            top: "40%",
            transform: "translateY(-50%)",
            background: "rgba(44, 62, 80, 0.8)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            transition: "all 0.3s ease",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "rgba(44, 62, 80, 1)")}
          onMouseOut={(e) => (e.currentTarget.style.background = "rgba(44, 62, 80, 0.8)")}
        >
          &#10094;
        </button>

        {/* Slide Content */}
        <div
          key={currentIndex}
          style={{
            animation: "slideIn 0.5s ease-out",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {activePost.full_picture && (
            <div style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
              <img
                src={Array.isArray(activePost.full_picture) ? activePost.full_picture[0] : activePost.full_picture}
                alt={`Novedad ${currentIndex + 1}`}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  marginBottom: "10px",
                  objectFit: "contain",
                  maxHeight: "450px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                }}
              />
              {(activePost.type === "Video" || activePost.btn_label?.toLowerCase().includes("video") || activePost.permalink_url?.includes("watch") || activePost.permalink_url?.includes("video")) && (
                <a
                  href={activePost.permalink_url}
                  target={activePost.target || "_blank"}
                  rel="noopener noreferrer"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "60px",
                    height: "60px",
                    background: "rgba(0, 0, 0, 0.7)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "22px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.4)",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  aria-label="Ver video"
                >
                  <i className="fa-solid fa-play" style={{ marginLeft: "4px" }}></i>
                </a>
              )}
            </div>
          )}
          <p
            style={{
              fontSize: "14px",
              color: "#555",
              marginBottom: "10px",
              minHeight: "40px",
              fontWeight: "500",
              lineHeight: "1.5",
              maxWidth: "500px",
            }}
          >
            {activePost.message.length > 150
              ? `${activePost.message.substring(0, 150)}...`
              : activePost.message}
          </p>
          <Link
            to={activePost.permalink_url || "/noticias"}
            target={activePost.target || (activePost.permalink_url?.startsWith("http") ? "_blank" : undefined)}
            rel={activePost.permalink_url?.startsWith("http") ? "noopener noreferrer" : undefined}
            onClick={() => {
              handleClose();
              if (!activePost.target || activePost.target !== "_blank") {
                scrollToTop();
              }
            }}
            className="tp-btn-xl green-anim"
            style={{
              textDecoration: "none",
              display: "inline-block",
              padding: "8px 20px",
              fontSize: "14px",
              borderRadius: "20px",
              marginTop: "5px",
            }}
          >
            {activePost.permalink_url ? (activePost.btn_label || "Más información") : "Ver en Noticias"}
          </Link>
        </div>

        {/* Right Arrow */}
        <button
          onClick={handleNext}
          aria-label="Siguiente"
          style={{
            position: "absolute",
            right: "5px",
            top: "40%",
            transform: "translateY(-50%)",
            background: "rgba(44, 62, 80, 0.8)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            transition: "all 0.3s ease",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "rgba(44, 62, 80, 1)")}
          onMouseOut={(e) => (e.currentTarget.style.background = "rgba(44, 62, 80, 0.8)")}
        >
          &#10095;
        </button>

        {/* Indicator Dots */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            marginTop: "15px",
          }}
        >
          {latestPosts.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              style={{
                width: idx === currentIndex ? "24px" : "8px",
                height: "8px",
                borderRadius: "4px",
                background: idx === currentIndex ? "#2c3e50" : "#bdc3c7",
                border: "none",
                cursor: "pointer",
                padding: 0,
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderStatic = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "center", marginBottom: "15px" }}>
        {latestPosts.map((post, idx) => (
          <div key={idx} style={{ flex: "1 1 400px", maxWidth: "480px" }}>
            {post.full_picture && (
              <img
                src={Array.isArray(post.full_picture) ? post.full_picture[0] : post.full_picture}
                alt={`Novedad ${idx + 1}`}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  marginBottom: "10px",
                  objectFit: "contain",
                  maxHeight: "550px",
                }}
              />
            )}
            <p style={{ fontSize: "14px", color: "#555", marginBottom: "10px", minHeight: "40px" }}>
              {post.message.length > 100
                ? `${post.message.substring(0, 100)}...`
                : post.message}
            </p>
            <Link
              to={post.permalink_url || "/noticias"}
              target={post.target || (post.permalink_url?.startsWith("http") ? "_blank" : undefined)}
              rel={post.permalink_url?.startsWith("http") ? "noopener noreferrer" : undefined}
              onClick={() => {
              handleClose();
              if (!post.target || post.target !== "_blank") {
                scrollToTop();
              }
            }}
              className="tp-btn-xl green-anim"
              style={{ textDecoration: "none", display: "inline-block", padding: "8px 16px", fontSize: "14px" }}
            >
              {post.permalink_url ? (post.btn_label || "Más información") : "Ver en Noticias"}
            </Link>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(5px)",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          padding: "20px",
          borderRadius: "15px",
          maxWidth: "1000px",
          width: "90%",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
          position: "relative",
          animation: "fadeIn 0.4s ease-out",
          textAlign: "center",
          maxHeight: "95vh",
          overflowY: "auto",
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            background: "transparent",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            color: "#333",
            fontWeight: "bold",
          }}
        >
          &times;
        </button>
        <h4 style={{ marginBottom: "15px", color: "#2c3e50" }}>
          ¡Últimas novedades!
        </h4>

        {latestPosts.length > 2 ? renderSlider() : renderStatic()}
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.9); }
            to { opacity: 1; transform: scale(1); }
          }
          @keyframes slideIn {
            from { opacity: 0; transform: translateX(20px); }
            to { opacity: 1; transform: translateX(0); }
          }
        `}
      </style>
    </div>
  );
}

export default AnnouncementModal;
